module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_20.0e7337e6.jpg";